// RTK Query tag type and IDs for the Scout threads API
export const SCOUT_THREAD_TAG_TYPE = 'ScoutThread' as const;
// Tags only the thread list, so refreshing it doesn't also refetch
// cached thread details (which carry every turn).
export const SCOUT_THREAD_LIST_ID = 'LIST' as const;
